import React from 'react';
import { Button, Icon, Stack, Text } from '@pairy/pds-react';

type Props = {
  children: React.ReactNode;
  title?: string;
  description?: string;
  onUpgradeClick?: () => void;
};

const PaywalledBlur = ({
  children,
  title = 'Pro 플랜 이상에서 확인할 수 있어요',
  description = '국가별 열람 통계로 해외/국내 리드 반응을 비교해보세요.',
  onUpgradeClick,
}: Props) => {
  return (
    <div style={{ position: 'relative', minHeight: 150 }}>
      {/* Blur layer */}
      <div
        style={{
          filter: 'blur(6px)',
          opacity: 0.6,
          pointerEvents: 'none',
          userSelect: 'none',
          minHeight: 150,
        }}
        aria-hidden
      >
        {children}
      </div>

      {/* Overlay */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 16,
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: 420,
            borderRadius: 12,
            background: 'rgba(255,255,255,0.92)',
            backdropFilter: 'blur(6px)',
            padding: 16,
            boxShadow: '0 10px 30px rgba(0,0,0,0.10)',
          }}
        >
          <Stack gap={12} direction={'column'} alignItems={'center'}>
            <Stack gap={8} direction={'column'} alignItems={'center'}>
              <Text variant="lg-semibold">{title}</Text>
              <Text variant="sm-medium" color="zinc_600">
                {description}
              </Text>
            </Stack>

            <Button
              variant="skyblue_400"
              leftIcon={<Icon icon="ph:magic-wand-fill" size={19} />}
              onClick={onUpgradeClick}
              width={'100%'}
            >
              업그레이드하고 확인하기
            </Button>
          </Stack>
        </div>
      </div>
    </div>
  );
};

export default PaywalledBlur;
